import { ProcesHandler } from '../../interfaces/FormConfig';
import { FormState, FormProps } from '../FormContainer';
import { GespreksRegistratieProcessHandlerHelpers } from './GespreksRegistratieProcessHandler';
import { IntakeProcessHandlerHelpers } from './IntakeProcessHandler';
import { PopupProcessHandlerHelpers } from './PopupProcessHandler';

export class ProcesName {
    // Init
    static readonly Init_done = 'Init_done';

    // Get
    static readonly Get_preprocess = 'RestGetPreProcess';
    static readonly Get_postprocess_Success = 'RestGetPostProcessSuccess';
    static readonly Get_postprocess_Fail = 'RestGetPostProcessFail';

    // Put
    static readonly Put_preprocess = 'RestPutPreProcess';
    static readonly Put_postprocess_Success = 'RestPutPostProcessSuccess';
    static readonly Put_postprocess_Fail = 'RestPutPostProcessFail';

    // Popup
    static readonly PopupOnOk = 'PopupOnOk';

    // CancelForm
    static readonly CancelForm = 'CancelForm';
    
}

export class ProcesHandlerHelpers {
    /**
     * Handleprocess will check if we have a given process.
     * If not, we can just continue the next satep in the process
     * and therefore the promise will be resolved as succesful.
     *
     * @param procesList
     * @param procesName
     * @param data
     */
    static handleProces(
        procesList: ProcesHandler[],
        procesName: string,
        component: React.Component<FormProps, FormState>,
        data: any
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            const [proces] = (procesList || []).filter(proces => proces.procesName === procesName);
            // Is custom proces Found?
            if (proces) {
                // Execute the proces and pass the result to the resolve / reject method of the promise
                proces.execute(component, data, resolve, reject);
            } else {
                if (procesName == ProcesName.Put_postprocess_Fail) {
                    // this is the ajax fail handler.. data is a ajax/http response
                    resolve({isError: true, ErrorText : data.responseText ?  data.responseText : "Er is een fout opgetreden."});
                } else
                if (data && data.status && data.status == 300) {      
                    // this is a normal ajax done handler ... if status is 300 then show generic error message            
                    resolve({HasError: true, ErrorText : "Er is een fout opgetreden."});
                } else {
                    // No action found. Treat as succes! 
                    resolve(data);
                }
            }
        });
    }

    static getProcessesForHander(handlers: string[] | string) {
        const processes: ProcesHandler[] = [];
        const procesHandlers = Array.isArray(handlers) ? handlers : [handlers];

        procesHandlers.forEach(handler => {
          if (handler === "gespreksregistratie") {
              processes.push(...GespreksRegistratieProcessHandlerHelpers.getProcesses());
          }
          if (handler === "intake") {
              processes.push(...IntakeProcessHandlerHelpers.getProcesses());
          }
          if (handler === "popup") {
              processes.push(...PopupProcessHandlerHelpers.getProcesses());
          }
        });
      
        return processes;
    }
}
